  <template>
  <v-dialog
    :value="value"
    @input="(v) => $emit('input', v)"
    max-width="898"
    transition="dialog-transition"
    scrollable
    persistent
  >
    <v-card v-if="value" color="neutral700" class="pos-r px-16" elevation="0">
      <v-card-title>
        <v-avatar size="24" @click="close" class="close_btn cursor-pointer">
          <img :src="require(`@/assets/icons/close.svg`)" />
        </v-avatar>
      </v-card-title>

      <v-card-text>
        <SimpleFileArea
          ref="SimpleFileArea"
          v-model="holdingFile"
          :img="previewImg"
          @update-img="(v) => (previewImg = v)"
          :rules="[
            (v) => !!v || $t('ARTWORK.EDIT.COPYWRITING.UPLOAD_YOUR_FILE')
          ]"
          hide-type-radio
          title="上傳壁貼"
        >
          <template #subtitle>
            <div>你可以透過上傳圖片來做為壁貼，新增在你的作品旁邊</div>
            <div>來做為補充或說明，或是其他純圖片展示用途</div>
          </template>
        </SimpleFileArea>

        <v-form ref="form" class="mt-5">
          <v-text-field
            :label="$t('ARTWORK.EDIT.WORD.WALLPAPER_NAME')"
            v-model="form.name"
            :rules="[$rules.required]"
            counter="128"
            background-color="neutral700"
            outlined
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions class="mb-6">
        <v-row>
          <v-col cols="12" class="flex-center">
            <v-btn width="120" outlined @click="close">
              {{ $t('COMMON.WORD.CANCEL') }}
            </v-btn>
            <SizeBox width="16" />
            <v-btn
              width="120"
              color="primary"
              @click="submit"
              :loading="isSubmiting"
            >
              {{ $t('COMMON.WORD.SAVE_CHANGES') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { addWallVision } from '@/api/panel/exhibitions';
import { addImageByCategory } from '@/api/panel/images';
import SimpleFileArea from '@/components/SimpleFileArea.vue';

export default {
  components: { SimpleFileArea },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    workData: {
      type: Object,
      default: null,
      required: true
    }
  },

  data() {
    return {
      previewImg: null,
      holdingFile: null,
      isSubmiting: false,
      form: {
        index: 0,
        name: '',
        wallVisionImageId: null
      }
    };
  },

  watch: {
    value(v) {
      v ? this.init() : this.reset();
    }
  },

  methods: {
    init() {
      this.form.index = this.workData.index;
      if (this.workData.data) {
        this.previewImg = this.workData.data.wallVisionImage.url;
        this.form.name = this.workData.data.name;
      }
    },
    reset() {
      const originData = this.$options.data();
      Object.keys(originData).forEach((key) => {
        this.$set(this.$data, key, originData[key]);
      });
      this.$refs.form.reset();
    },
    close() {
      this.$emit('input', false);
    },
    async submit() {
      if (!this.$refs.form.validate() || !this.$refs.SimpleFileArea.$validate())
        return;
      this.isSubmiting = true;

      if (this.holdingFile) {
        const formData = new FormData();
        formData.append('file', this.holdingFile);

        const { id, url, error } = await addImageByCategory({
          category: 'wallVision',
          data: formData
        });

        if (error) {
          this.$toast.error(this.$t('ARTWORK.EDIT.TOAST.ALERT.BUILD_FAIL'));
          this.isSubmiting = false;
          return;
        }

        this.form.wallVisionImageId = id;
      } else {
        this.form.wallVisionImageId = this.workData.data.wallVisionImage.id;
      }

      this.form.index = this.workData.index;

      const Work = await addWallVision({
        id: this.$route.params.expoId,
        ...this.form
      });

      if (!Work.error) {
        this.$emit('save', Work);
        this.$toast(this.$t('ARTWORK.EDIT.TOAST.SUCCESS.BUILD_SUCCESSFUL'));
      } else {
        this.$toast.error(this.$t('ARTWORK.EDIT.TOAST.ALERT.BUILD_FAIL'));
      }

      this.isSubmiting = false;

      this.$emit('input', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.close_btn {
  position: absolute;
  top: 8px;
  right: 8px;
}

.file_area {
  * {
    user-select: none;
  }
  position: relative;
  border: 1px dashed;
  border-color: $neutral300;
  border-radius: 6px;
  background-color: $neutral700;

  &.isError {
    border-color: $error;
  }

  &.isGrabing {
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      width: calc(100% - 8px);
      height: calc(100% - 8px);
      background-color: rgba($neutral100, $alpha: 0.6);
      border-radius: 6px;
      border: 2px solid $primary;
    }
  }
}

.image_in_frame {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>